<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <SearchCollapse :expanded="true" title="Filtros de Mapeamento">
        <div class="form-group">
          <label>Grupo AD:</label>
          <v-select
            v-model="form.adGroupName"
            :options="availableGroupsOptions"
            :reduce="(option) => option.value"
            label="name"
            placeholder="Selecione um grupo AD"
            clearable
            class="w-100"
          >
            <template v-slot:no-options>
              Nenhum grupo encontrado.
            </template>
          </v-select>
        </div>

        <div class="form-group">
          <label>Permissões:</label>
          <v-select
            multiple
            v-model="form.permissoes"
            :options="permissoesOptions"
            :reduce="(option) => option.value"
            label="name"
            placeholder="Selecione permissões"
            clearable
            class="w-100"
          >
            <template v-slot:no-options>
              Nenhuma permissão encontrada.
            </template>
          </v-select>
        </div>

        <div class="form-group">
          <label>Acessos:</label>
          <v-select
            multiple
            v-model="form.acessos"
            :options="acessosOptions"
            :reduce="(option) => option.value"
            label="name"
            placeholder="Selecione acessos"
            clearable
            class="w-100"
          >
            <template v-slot:no-options>
              Nenhum acesso encontrado.
            </template>
          </v-select>
        </div>
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import { PERMISSIONS_OPTIONS, ACCESS_OPTIONS } from '@/shared/constants/permissionsAndAccessOptions'
import 'vue-select/dist/vue-select.css'
import adSyncService from '@/shared/http/repositories/adsync/adsync'

export default {
  name: 'SidebarGroupMappings',
  components: { SidebarSearch, SearchCollapse },
  data () {
    return {
      form: {
        adGroupName: null,
        permissoes: [],
        acessos: []
      },
      permissoesOptions: PERMISSIONS_OPTIONS,
      acessosOptions: ACCESS_OPTIONS,
      availableGroups: []
    }
  },
  computed: {
    availableGroupsOptions () {
      return this.availableGroups.map(group => ({
        name: group.groupName,
        value: group.groupName
      }))
    }
  },
  mounted () {
    this.loadAvailableGroups()
    this.$root.$on('clearForm', () => {
      this.form.adGroupName = null
      this.form.permissoes = []
      this.form.acessos = []
    })
  },
  methods: {
    async loadAvailableGroups () {
      try {
        const response = await adSyncService.getAvailableGroups()
        this.availableGroups = response.data || []
      } catch (error) {
        console.error('Erro ao carregar grupos:', error)
      }
    },
    submitForm () {
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.form.adGroupName = null
      this.form.permissoes = []
      this.form.acessos = []
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
      })
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 0.5rem;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/ADSync/components/search/SidebarGroupMappings.vue